import { call, put, select } from 'redux-saga/effects';
import { selectQuizEntities } from 'features/quizzes/quizzesSlice';
import { quizzesContentCleared } from 'features/quizzes/actions';
import { closeActionNotification } from 'features/notifications/thunks/closeActionNotification';
import { QuizEntities } from 'features/quizzes/types';
import { Action } from '@reduxjs/toolkit';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { selectNotificationsByScope } from 'features/notifications/notificationsSlice';
import { NotificationId } from 'features/notifications/types';
import { FeatureFlag } from 'features/feature-set/types';
import { closeActionNotifications } from 'features/notifications/thunks/closeActionNotifications';

export function* clearQuizzesSaga() {
  const canManagePolls: boolean = yield call(hasPermissionsSaga, PermissionTypes.managePolls);

  if (!canManagePolls) {
    const notificationIds: NotificationId[] = yield select(
      selectNotificationsByScope,
      FeatureFlag.polls
    );

    if (notificationIds.length > 0) {
      const cleanupNotificationsThunk: Action = yield call(
        closeActionNotifications,
        notificationIds
      );
      yield put(cleanupNotificationsThunk);
    }
  } else {
    const entities: QuizEntities = yield select(selectQuizEntities);

    for (const quiz of Object.values(entities)) {
      if (quiz.status === 'launched') {
        const notificationThunk: Action = yield call(
          closeActionNotification,
          `quiz_launched_${quiz.id}`
        );
        yield put(notificationThunk);
      }
    }
  }

  yield put(quizzesContentCleared({ canManagePolls }));
}
